import {
	array,
	boolean,
	intersect,
	literal,
	nullable,
	number,
	partial,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Type as Change } from '../../../../job/hitlv2/change/Type';
import { Id as StepId } from '../../../../job/hitlv2/step/Id';

const RequestPageFields = struct({
	pageNumber: iotsUtils.PositiveInteger1Based,
	version: number,
	stepId: StepId,
});

const MergedRequestPage = intersect(RequestPageFields)(
	intersect(
		struct({
			changes: iotsUtils.NonEmptyArray(Change),
		})
	)(
		partial({
			replaceExisting: boolean,
		})
	)
);

const ReplacedRequestPage = intersect(RequestPageFields)(
	struct({
		changes: array(Change),
		replaceExisting: literal(true),
	})
);

const RequestPage = union(ReplacedRequestPage, MergedRequestPage);

export const Request = intersect(
	struct({
		pages: iotsUtils.NonEmptyArray(RequestPage),
	})
)(
	partial({
		draftRevision: nullable(string),
	})
);
